import {Observable} from 'rxjs';

export abstract class BlockedPopupReporter {
  /**
   * Tells user that if wasn't possible to do a refresh because of blocked popup.
   */
  public abstract open(): Observable<null>;
}
